import { Button, Icon } from '@design-system';
import { useTranslation } from 'next-i18next';

import { useFlow } from '../../../providers';

export const HowItWorksStep = () => {
  const { t } = useTranslation('product');
  const { goNextStep } = useFlow();

  return (
    <div className="flex flex-col gap-6 px-6 pb-6">
      <div className="flex gap-3">
        <div>
          <Icon name="ic_ticket" size="sm" />
        </div>
        <div className="pt-0.5">
          <h4>{t('drawers.offer.how_it_works.make_offer.title')}</h4>
          <p className="text-neutral-4">
            {t('drawers.offer.how_it_works.make_offer.description')}
          </p>
        </div>
      </div>
      <div className="flex gap-3">
        <div>
          <Icon name="ic_schedule" size="sm" />
        </div>
        <div className="pt-0.5">
          <h4>{t('drawers.offer.how_it_works.check_match.title')}</h4>
          <p className="text-neutral-4">
            {t('drawers.offer.how_it_works.check_match.description')}
          </p>
        </div>
      </div>
      <div className="flex gap-3">
        <div>
          <Icon name="ic_check_circle" size="sm" />
        </div>
        <div className="pt-0.5">
          <h4>{t('drawers.offer.how_it_works.receive_offer.title')}</h4>
          <p className="text-neutral-4">
            {t('drawers.offer.how_it_works.receive_offer.description')}
          </p>
        </div>
      </div>
      <Button
        fullWidth
        label={t('drawers.bid.save')}
        onClick={goNextStep}
        type="button"
        variant="primary"
      />
    </div>
  );
};
